/**
 * SAP PI RESTAdapter paths sent as `endpoint` on POST /api/sap/proxy.
 */
export const SAP_PROXY_ENDPOINTS = {
  VENDOR_CREATION: "/VendorCreation",
  VENDOR_CHANGE: "/VendorChange",
  VENDOR_BLOCK_UNBLOCK: "/VendorBlockUnBlock",
  PR_CREATION: "/PRCreation",
  PO_CREATION: "/POCreationIn",
  GRN: "/GRN",
  SERVICE_ENTRY_SHEET: "/ServiceEntrySheet",
  GRN_CANCELLATION: "/GRNCancellation",
  SERVICE_ENTRY_SHEET_CANCELLATION: "/ServiceEntrySheetCancellation",
  PARK_INVOICE: "/ParkInvoice",
};
